/**
 * MobileShiftDrawer Component
 *
 * A bottom sheet drawer for displaying ShiftView on mobile devices.
 * Features:
 * - SwipeableDrawer from bottom
 * - 70vh default height, expandable
 * - Swipe-to-close gesture
 * - Visual swipe indicator bar
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { SwipeableDrawer, Box } from '@mui/material';

const DRAWER_BLEEDING = 0;
const DRAWER_HEIGHT = '70vh';

const MobileShiftDrawer = ({
  open,
  onOpen,
  onClose,
  children,
}) => {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      swipeAreaWidth={DRAWER_BLEEDING}
      disableSwipeToOpen
      ModalProps={{
        keepMounted: true,
      }}
      PaperProps={{
        sx: {
          height: DRAWER_HEIGHT,
          overflow: 'visible',
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
        },
      }}
    >
      {/* Swipe Indicator */}
      <Box
        sx={{
          position: 'absolute',
          top: 8,
          left: '50%',
          transform: 'translateX(-50%)',
          width: 40,
          height: 6,
          backgroundColor: 'grey.400',
          borderRadius: 3,
        }}
      />

      {/* Content Container */}
      <Box
        sx={{
          pt: 3,
          pb: 2,
          px: 2,
        }}
      >
        {children}
      </Box>
    </SwipeableDrawer>
  );
};

MobileShiftDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default memo(MobileShiftDrawer);
